import PropTypes from "prop-types";
import React from 'react';

const Brand = ({ data }) => {
  return (
    <div className="brand">
      <a href={data.url}>
        <img src={process.env.PUBLIC_URL + data.image} alt="logo image" />
      </a>
    </div>
  )
}

Brand.propTypes = {
  data: PropTypes.object
}



export default Brand;
